import { CMSContext, ContextData } from 'context/CMSProvider';
import { useContext } from 'react';

export default (selector: (data: ContextData) => any) => {
  const context = useContext(CMSContext);
  const data = selector(context);

  return typeof data === 'undefined' ? {} : data;
};
